import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolder1"><Path d="M10.5352 3H2V20H22V6H12.5352L10.5352 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder1;
